import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DocumentB2c } from '../../model/document.model';

@Component({
  selector: 'raf-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileDownloadComponent{

  @Input()
  file?: DocumentB2c;

  @Input()
  size: 'medium' | 'small' = 'small';

}
